// import { ck, cr, URLS } from "fire-wind-water";
// import service from "@/services/authService";
import { cr, interact, ck, URLS } from "fire-wind-water";
import { URLSearchParams } from "core-js/modules/web.url-search-params";

class Common {
  memberFormId =
    URLS.getURL("memberFormId") || URLS.getHash("memberFormId") || ""; //  表单ID
  sourceKey = URLS.getURL("sourceKey") || URLS.getHash("sourceKey") || "";
  configId = URLS.getURL("configId") || URLS.getHash("configId") || "";
  memberSchemaId =
    URLS.getURL("memberSchemaId") || URLS.getHash("memberSchemaId") || "";
  schemaId =
    URLS.getURL("memberSchemaId") || URLS.getHash("memberSchemaId") || ""; // 体系ID
  weChatId = URLS.getURL("weChatId") || URLS.getHash("weChatId") || "";
  // backUrl = "https://tf.smarket.net.cn/t/template/d95bc60d58dd9051c3c91c0971bfdce8/views/customForm.html?customFormId=2110272932234843&instanceId=264996&linkId=139476&configId=1052577&returnUrl=https%3A%2F%2Ftf.smarket.net.cn%2Ft%2Ftemplate%2FhQAwvq%2Findex.html%3FseminarId%3D2110273982229750%26signPointId%3D49686%26configId%3D1052575%26weChatId%3D%23%2Fverify#";
  backUrl = URLS.getURL("backUrl") || URLS.getHash("backUrl") || "";
  returnUrl = "";
  preview = URLS.getURL("preview") || URLS.getHash("preview") || "";
  token = URLS.getURL("token") || URLS.getHash("token");
  verify = URLS.getURL("verify") || URLS.getHash("verify");
  markCode = URLS.getURL("markCode") || URLS.getHash("markCode");
  track_id = URLS.getURL("track_id") || URLS.getHash("track_id");
  tc = URLS.getURL("tc") || URLS.getHash("tc");
  webinarId = URLS.getURL("webinarId") || URLS.getHash("webinarId");
  seminarId = URLS.getURL("seminarId") || URLS.getHash("seminarId");
  tenantId = ""; // 租户Id
  globalUserId = "";
  setSession;
  setVerify;
  setVerifyInfo;
  setToken;
  setTokenInfo;
  getSession;
  getToken;
  getTokenInfo;
  getVerify;
  getVerifyInfo;
  removeVerify;
  removeVerifyInfo;
  removeTokenInfo;
  removeToken;
  removeSession;
  getOpenId;
  isMobile = interact.isMobile;
  platform;
  routerQuery;

  handBackUrl(backUrl) {
    // let oldBackUrl = backUrl;
    // let newBackUrl = decodeURIComponent(oldBackUrl);
    // while (oldBackUrl != newBackUrl) {
    //   oldBackUrl = newBackUrl;
    //   newBackUrl = decodeURIComponent(oldBackUrl);
    // }
    backUrl = decodeURIComponent(backUrl);
    backUrl = window.$sk.goto(backUrl);
    return backUrl;
  }

  handPage(formInfo) {
    if (URLS.getURL("preview") !== "1") {
      let url = window.location.href;
      let urlConfigId = URLS.getURL("configId");
      if (this.isMobile && urlConfigId == formInfo.pcConfigId) {
        url = URLS.updateSearchParam("configId", formInfo.wapConfigId, url);
        url = url.replace("pc_", "wap_");
        window.location.replace(url);
      } else if (!this.isMobile && urlConfigId == formInfo.wapConfigId) {
        url = URLS.updateSearchParam("configId", formInfo.pcConfigId, url);
        url = url.replace("wap_", "pc_");
        window.location.replace(url);
      }
    }
  }

  register(json) {
    ck.json = true;
    this.platform = this.platform
      ? this.platform
      : this.isMobile
      ? "wap"
      : "pc";
    this.routerQuery = window.$sk.template.get().common.router;
    this.globalUserId = json.user.globalUserId;
    this.tenantId = json.common.tenantId || "";
    this.setSession = json.cookie.setSession;
    this.getSession = json.cookie.getSession;
    this.removeSession = json.cookie.removeSession;
    this.setVerify = json.cookie.setVerify;
    this.getVerify = json.cookie.getVerify;
    this.removeVerify = json.cookie.removeVerify;
    this.setVerifyInfo = json.cookie.setVerifyInfo;
    this.getVerifyInfo = json.cookie.getVerifyInfo;
    this.removeVerifyInfo = json.cookie.removeVerifyInfo;
    this.setToken = json.cookie.setToken;
    this.getToken = json.cookie.getToken;
    this.removeToken = json.cookie.removeToken;
    this.setTokenInfo = json.cookie.setTokenInfo;
    this.getTokenInfo = json.cookie.getTokenInfo;
    this.removeTokenInfo = json.cookie.removeTokenInfo;
    this.getOpenId = json.cookie.getOpenId;
    if (json.common.schemaId) this.schemaId = json.common.schemaId;
  }

  params() {
    let obj = {};
    if (this.weChatId) obj.weChatId = this.weChatId;
    if (this.memberSchemaId) obj.memberSchemaId = this.memberSchemaId;
    if (this.schemaId) obj.schemaId = this.schemaId;
    if (this.preview) obj.preview = this.preview;
    // if (this.backUrl) obj.backUrl = this.backUrl;
    return obj;
  }

  routerPush(self, url, o) {
    let params = Object.assign({}, this.routerQuery, o);
    // console.log(this.platform);
    self.$router.push({
      path: `./${this.platform}_${url}`,
      query: params,
    });
  }

  routerReplace(self, url, o) {
    let params = Object.assign({}, this.routerQuery, o);
    self.$router.replace({
      path: `./${this.platform}_${url}`,
      query: params,
    });
  }

  removeTokenPush(url, type) {
    let params = new URLSearchParams(window.location.search);
    params.delete("token");
    let newUrl =
      URLS.removeSearchParam(
        window.location.origin +
          window.location.pathname +
          "?" +
          params.toString() +
          (!this.isMobile ? "#/pc_" : "#/wap_") +
          url,
        ["token"]
      ) + `?type=${type || ""}`;
    let o = cr.extend({}, this.routerQuery);
    // console.log(o);
    if (o.token) {
      delete o.token;
    }
    Object.keys(o).forEach((key) => {
      newUrl += `&${key}=${o[key]}`;
    });
    // console.log(newUrl);
    window.$sk.goto(newUrl);
  }
}

export const common = new Common();
